import { Link } from 'react-router-dom';
import NewsSection from "../components/News/NewsSection";


export default function News() {
    return (
        <>
            <NewsSection />
        </>
    );
}
